import api from '../utils/api';

export async function getProfile(username) {
  const params = username ? { params: { username } } : {};
  const response = await api.get('/profile', params);
  return response.data.data;
}

export async function updateProfile(targetUsername, updates) {
  const response = await api.put('/profile', {
    target_username: targetUsername,
    updates,
  });
  return response.data.data;
}

export async function getEmployees() {
  const response = await api.get('/employees');
  return response.data.data;
}
